import React from 'react';
import { StyledOCard } from './index.styles';
import { Button } from '@marriott/mi-ui-library';
import { addSubDirectoryPrefix } from '../../utils/src/helper';
import moment from 'moment';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';

interface GeoCodeInfo {
  details?: {
    location?: {
      city?: string;
      address?: string;
      latitude?: number;
      longitude?: number;
    };
  };
  placeId?: string;
}

interface LlmMetadata {
  llmInfo?: {
    date?: {
      earliest?: string;
      latest?: string;
    };
  };
}

interface OCardProps {
  className?: string;
  onSearchAllClick?: () => void;
  title?: string;
  buttonText?: string;
  geoCodeInfo?: GeoCodeInfo;
  llmMetadata?: LlmMetadata;
}

export const OCard: React.FC<OCardProps> = ({
  className = '',
  onSearchAllClick,
  geoCodeInfo,
  title = 'Looking for more properties?',
  buttonText = 'Search All Properties',
  llmMetadata,
}) => {
  const { latitude, longitude } = geoCodeInfo?.details?.location || {};
  const { placeId } = geoCodeInfo || {};
  const { earliest, latest } = llmMetadata?.llmInfo?.date || {};
  const locationName = geoCodeInfo?.details?.location?.city || geoCodeInfo?.details?.location?.address || '';
  const envVars = useClientEnvVarsStore.getState().envVarsObject;
  const homeRedirectUrl = envVars['NEXT_PUBLIC_HOME_URL'] || '';
  const findHotelsUrl = envVars['NEXT_PUBLIC_FIND_HOTELS_URL'] || '';

  const formatExitURL = (
    findHotelsUrl: string,
    latitude: number,
    longitude: number,
    placeId: string,
    earliest: string,
    latest: string
  ) => {
    console.log('longitude', longitude);
    console.log('latitude', latitude);
    const urlQueryParams = `?${earliest ? `fromDate=${moment(earliest).format('MM/DD/YYYY')}` : ''}${
      latest ? `&toDate=${moment(latest).format('MM/DD/YYYY')}` : ''
    }&isSearch=true&${placeId ? `&destinationAddress.placeId=${placeId}` : ''}`;
    return addSubDirectoryPrefix(findHotelsUrl) + urlQueryParams;
  };

  const findHotelsRedirectURL = formatExitURL(
    findHotelsUrl,
    latitude || 0,
    longitude || 0,
    placeId || '',
    earliest || '',
    latest || ''
  );

  const handleSearchClick = () => {
    if (onSearchAllClick) {
      onSearchAllClick();
    }
  };

  return (
    <StyledOCard className={`o-card-centered ${className}`} data-testid="o-card">
      <div className="content-wrapper">
        <p className="title-text" data-testid="o-card-title">
          {locationName ? `Looking for all properties in ${locationName}?` : title}
        </p>
      </div>
      <Button className="search-all-button m-button-primary" callback={handleSearchClick} data-testid="o-card-button">
        <a
          rel="noreferrer"
          className="search-all-button-link"
          href={latitude ? findHotelsRedirectURL : homeRedirectUrl}
          // target="_blank"
        >
          {buttonText}
        </a>
      </Button>
    </StyledOCard>
  );
};

export default OCard;
